export default __webpack_public_path__ + "static/media/caixa-saude-map-image.609f2fc2.png";